<app-window [visible]="isVisible" title="{{'settings' | transloco}}" [width]="'500px'" [height]="'400px'"
  position="center" [showClose]="true" [showHide]="false" [blockBackground]="true" [showTransparency]="false"
  (close)="onWindowClose()">
  <div>
    <div class="controls">
      <div class="setting-left">
        <span class="setting-label">{{'language' | transloco}}</span>
        <molv-dropdown [(value)]="language" (valueChange)="onLangChange($event)" [options]="[
            { value: supportedLangs.EN, label: 'ENG' },
            { value: supportedLangs.CS, label: 'CZ' },
            { value: supportedLangs.RU, label: 'RU' },
            { value: supportedLangs.ES, label: 'ES' }
          ]">
        </molv-dropdown>
      </div>
      <div class="setting-left">
        <span class="setting-label">{{ 'showBlurredContent' | transloco }}:</span>
        <molv-switch [checked]="showBlurredContent()"
          (checkedChange)="onShowBlurredContentChange($event)"></molv-switch>
      </div>
      <div class="setting-left">
        <span class="setting-label">{{ 'hideBlurredContent' | transloco }}:</span>
        <molv-switch [checked]="hideBlurredManga()" (checkedChange)="onHideBlurredContentChange($event)"></molv-switch>
      </div>
      <div class="setting-left">
        <span class="setting-label">{{'update' | transloco}}</span>
        <button class="molv-btn molv-btn-pink" [disabled]="!updateAvailable()" (click)="updateApp()"> {{'update' |
          transloco}} </button>
      </div>
    </div>
  </div>
</app-window>